import { serializeMarketingParams } from './parse'
import {
  captureFromCurrentUrl,
  getMarketingParams,
  getTwReferrer,
} from './store'

export type BookingAttributionPayload = {
  twReferrer?: string
  urlParams?: string
}

const MAX_TW_REFERRER_LENGTH = 2048
const MAX_URL_PARAMS_LENGTH = 4096

/**
 * Snapshot of marketing attribution for the booking POST body. Captures from
 * the current URL first so a late-arriving param isn't missed, then serializes
 * allowlisted params (excluding tw_referrer) and the original landing referrer.
 * Omits empty fields so the request body stays clean when there's nothing to send.
 */
export function getBookingAttributionPayload(): BookingAttributionPayload {
  captureFromCurrentUrl()

  const twReferrer = getTwReferrer()
  const urlParams = serializeMarketingParams(getMarketingParams())

  const payload: BookingAttributionPayload = {}

  if (twReferrer && twReferrer.length <= MAX_TW_REFERRER_LENGTH) {
    payload.twReferrer = twReferrer
  }

  if (urlParams && urlParams.length <= MAX_URL_PARAMS_LENGTH) {
    payload.urlParams = urlParams
  }

  return payload
}
